import { useMemo, useState, useEffect } from "react";

import type { HotelApplicationDataQueryQuery } from "@/lib/gql/__generated__/graphql";

type Props = {
	isNew: boolean;
	hotelApplicationData: HotelApplicationDataQueryQuery;
};

export const useModalState = ({ isNew, hotelApplicationData }: Props) => {
	const shouldShowModal = useMemo(() => {
		// テスト予約が利用可能な場合は、モーダルを開く
		return isNew && hotelApplicationData.hotelApplicationStatus.isTestReservationAvailable;
	}, [hotelApplicationData.hotelApplicationStatus.isTestReservationAvailable, isNew]);

	const [open, setOpen] = useState(shouldShowModal);

	// shouldShowModalの値が変わったときにopenを更新
	useEffect(() => {
		setOpen(shouldShowModal);
	}, [shouldShowModal]);

	const closeModal = () => {
		setOpen(false);
	};

	return {
		open,
		closeModal,
	};
};
